import { ReactNode } from 'react';

export const boldText = (chunks: ReactNode) => {
    return <strong className="font-semibold">{chunks}</strong>;
};

export const italicText = (chunks: ReactNode) => {
    return <em className="italic">{chunks}</em>;
};

export const paragraph = (chunks: ReactNode) => {
    return <p className="mb-4">{chunks}</p>;
};

export const defaultValues = {
    b: boldText,
    strong: boldText,
    i: italicText,
    em: italicText,
    p: paragraph,
};
